import React, { useEffect } from "react";
import { Route, Routes } from "react-router";
import { otherRoutes } from "./router.link";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import AuthFeature from "../authFeature";

import { AcademicYearProvider } from "../../core/common/context/AcademicYearContext";
import { PermissionsProvider } from "../../core/common/context/PermissionsUserContext";
import Error404 from "../pages/error/error-404";
import { useDispatch, useSelector } from "react-redux";
import { loadUserDataThunk } from "../../core/data/redux/authSlice";
import { AppDispatch } from "../../core/data/redux/store";
import { getPrivateRoutes } from "./privateRoutesContainer";
import { CurrentClassProvider } from "../../core/common/context/studentClassContext";
import { SocketProvider } from "../../core/common/context/SocketContext";
import { ChildrenDetailProvider } from "../../core/common/context/ChildrenDetailsContext";

const ALLRoutes: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const userType = useSelector((state: any) => state.auth.userType);
  const isUserLoaded = useSelector((state: any) => state.auth.isUserLoaded);

  useEffect(() => {
    // if (isUserLoaded && isAuthenticated) return;
    dispatch(loadUserDataThunk());
  }, [dispatch]);

  if (!isUserLoaded) {
    return (
      <div className="h-100 w-100">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SocketProvider>
        <AcademicYearProvider>
          <PermissionsProvider>
            <CurrentClassProvider>
              <ChildrenDetailProvider>
                <NuqsAdapter>
                  <Routes>
                    {/* Routes privées – protégées par le container */}
                    {isUserLoaded && userType && getPrivateRoutes(userType)}

                    {/* other routes */}
                    <Route element={<AuthFeature />}>
                      {otherRoutes.map((route, idx) => (
                        <Route
                          path={route.path}
                          element={route.element}
                          key={route.path}
                        />
                      ))}
                    </Route>
                    {/* route 404 */}
                    <Route path="*" element={<Error404 />} />
                  </Routes>
                </NuqsAdapter>
              </ChildrenDetailProvider>
            </CurrentClassProvider>
          </PermissionsProvider>
        </AcademicYearProvider>
      </SocketProvider>
    </>
  );
};

export default ALLRoutes;
